import { ReferralDocumentType } from '../schemas/enums';

// Every file of a referral lives in the referral's own storage folder — the
// prefix an uploaded document is checked against before it is accepted
// (PPL-3549).
export const getReferralDocumentsFolderRef = (referralId: string) =>
  `referrals/${referralId}/`;

// Only what a storage object name is allowed to carry, so a file name from a
// partner payload cannot reshape the path it is stored under.
const safeFileName = (fileName: string) =>
  fileName
    .trim()
    .replace(/[^A-Za-z0-9._-]+/g, '_')
    .slice(-100);

// Where a referral document is stored: the same
// "referrals/{referralId}/{type}-{timestamp}-{fileName}" layout the web
// referral forms upload to, so both transports produce one folder layout.
export const getReferralDocumentFileRef = ({
  referralId,
  type,
  fileName,
  uploadedAt,
}: {
  referralId: string;
  type: ReferralDocumentType;
  fileName: string;
  uploadedAt: Date;
}) =>
  `${getReferralDocumentsFolderRef(referralId)}${type}-${uploadedAt.getTime()}-${safeFileName(
    fileName,
  )}`;
